<script setup>
import {computed, ref} from "vue";
import MembersModal from "./MembersModal.vue";
import {pgettext} from "@/utils/translate";
import {mdiPencilOutline} from "@mdi/js";
import {useQuery} from "@vue/apollo-composable";
import {useLastResult} from "@/graphql/composable";
import {HpoHospitalList} from "@/graphql/queries/hpo/hpoHospitalList.graphql"

const props = defineProps({
  hpoId: {
    type: String,
    required: true
  },
  member: {
    type: Object,
    required: true
  },
  hospitalsTrackerTimestamp: {
    type: Object,
    required: false
  },
  hpoPassword: {
    type: String,
    required: false,
    default: null
  },
});

const showModal = ref(false)

const hospitalsQueryVariables = computed(() => ({
  updateTimestamp: props.hospitalsTrackerTimestamp,
  hpoId: props.hpoId,
}));
const {result: hospitalsResult} = useQuery(HpoHospitalList, hospitalsQueryVariables)
const hospitalList = useLastResult(hospitalsResult, [], data => data.hpoHospitalList)
</script>

<template>
  <div class="hpo-members">
    <v-btn color="primary"
           variant="elevated"
           density="compact"
           :prependIcon="mdiPencilOutline"
           @click="showModal=true">
      <span>{{ pgettext('action', 'Edit Team') }}</span>
    </v-btn>
  </div>

  <MembersModal v-if="showModal"
                ref="membersModal"
                :hpoId="hpoId"
                :member="member"
                :hpoPassword="hpoPassword"
                :hospitalList="hospitalList"
                @close="showModal=false"/>

</template>